import { gql } from '@apollo/client';
import { renewalQuotation } from './fragments';

export const POLICY_RENEWAL_LIST_QUERY = gql`
  query renewalPolicies($pager: PagerInputNew, $filters: RenewalPolicyFilterInput!, $options: ListQueryOptions) {
    renewalPolicies(pager: $pager, filters: $filters, options: $options) {
      total
      renewalPolicyIds
      values {
        documentId
        documentNumber
        renewalPolicyDocument {
          documentId
          documentNumber
          documentState
          contractNumber
          contractState
          contractFinishDate
          monthNo
          period
          startDate
          finishDate
          remainingDays
          amount
          currencyCode
          insurerId
          insurerName
          cascoInsurerId
          cascoInsurerName
          quotationsDate
          sentToClientDate
          additionalInfo
          warnings
          comments
          client {
            partnerId
            partnerName
            uniqueID
          }
          insured {
            partnerId
            partnerName
            uniqueID
          }
          asset {
            itemId
            brand
            model
            chassisNumber
            registrationNumber
            manufacturingYear
            cylindricCapacity
            enginePower
            maxWeight
            seatsNumber
          }
          quotations {
            insurerId
            insurerName
            period
            insuranceAmount
            currencyCode
          }
        }
      }
    }
  }
`;

export const QUOTATIONS_QUERY = gql`
  query quotations($documentId: Int!) {
    quotations(documentId: $documentId) {
      documentId
      quotations {
        ...renewalQuotation
      }
    }
  }
  ${renewalQuotation}
`;

export const POLICY_RENEWAL_ITEMS = gql`
  {
    policyRenewalItems @client {
      data {
        renewalDocumentId
        documentNumber
        quotationsDate
        sentToClientDate
        selected
      }
    }
  }
`;

export const RENEWAL_DOCUMENT_AUXILIARY_DATA = gql`
  query renewalDocumentAuxiliaryData($renewalDocumentId: Int!) {
    renewalDocumentAuxiliaryData(renewalDocumentId: $renewalDocumentId) {
      renewalDocumentId
      additionalInfo
    }
  }
`;

export const ASSET_TYPES_QUERY = gql`
  query assetTypes {
    assetTypes {
      id
      value
    }
  }
`;
